import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import { selectAttributeInfo } from '../../../store/options/options.selector';
import { selectModelTrend } from '../../../store/data/data.selector';

import MarkdownToJsx from '../../markdown-to-jsx/markdown-to-jsx.component';


export default function ProjectionText({ place, chartTab }) {
  const attributeInfo = useSelector(selectAttributeInfo);
  const modelTrendData = useSelector(selectModelTrend);

  let eFuture;
  if (chartTab === 'veryHigh') {
    eFuture = '5-8.5';
  }else if (chartTab === 'high') {
    eFuture = '3-7.0';
  } else {
    eFuture = '2-4.5';
  }

  const mdPath = [process.env.PUBLIC_URL, 'markdown'].join('/');

  return (
    <>
      <Typography>
        <span>
          In {place}, climate model projections of the {attributeInfo.text} for
          a {chartTab} emissions future (
        </span>
        <a
          key='loca2'
          target='_blank'
          rel='noreferrer'
          href='https://loca.ucsd.edu/loca-version-2-for-north-america-ca-jan-2023/'
        >
          LOCA2 SSP{eFuture}
        </a>
        <span>
          ) shows an average{' '}
          {modelTrendData.avgDiff > 0 ? 'increase' : 'decrease'} by{' '}
          {Math.abs(modelTrendData.avgDiff)}
          {attributeInfo.units} when comparing{' '}
          {modelTrendData.projectedTimeRange} to {modelTrendData.pastTimeRange}.
        </span>
      </Typography>

      <Typography>
        <b>SOURCE:</b>{' '}
        <a
          target='_blank'
          href='https://www.sciencedirect.com/science/article/pii/S0959378015000060#fig0005'
          rel='noreferrer'
        >
          LOCA2 SSP{eFuture}
        </a>{' '}
        accessed through{' '}
        <a target='_blank' href='https://www.rcc-acis.org/' rel='noreferrer'>
          ACIS
        </a>
        .
      </Typography>

      <MarkdownToJsx path={`${mdPath}/state_detail_projection_note1.md`} />

      {attributeInfo.precip && <MarkdownToJsx path={`${mdPath}/state_detail_projection_note2.md`} />}
    </>
  );
}

ProjectionText.propTypes = {
  place: PropTypes.string,
  chartTab: PropTypes.string,
};
